window.addEventListener('load', function () {

  const cards = document.querySelectorAll('.itu-cards-icons-item');
  let activeModal = null;
  let activeOverlay = null;
  let sourceCard = null;     // référence à la carte d'origine
  let escListener = null;    // listener Escape courant (pour pouvoir le retirer)
  let isAnimating = false;   // garde contre les clics rapides pendant transitions

  /* =========================================
     SCROLL LOCK
  ========================================= */

  function lockScroll() {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = scrollbarWidth + 'px';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  /* =========================================
     CLOSE MODAL
  ========================================= */

  function closeModal() {
    if (!activeModal || !activeOverlay || isAnimating) return;

    isAnimating = true;

    // Toujours retirer le listener Escape, peu importe par où on ferme
    if (escListener) {
      document.removeEventListener('keydown', escListener);
      escListener = null;
    }

    activeModal.classList.remove('is-visible');
    activeOverlay.classList.remove('is-visible');

    setTimeout(() => {
      // Remettre le modal-content original dans sa carte
      if (activeModal && sourceCard) {
        activeModal.style.display = '';
        activeModal.style.visibility = '';
        sourceCard.appendChild(activeModal);
      }

      if (activeOverlay) activeOverlay.remove();

      document.body.classList.remove('modal-open');
      unlockScroll();

      activeModal = null;
      activeOverlay = null;
      sourceCard = null;
      isAnimating = false;
    }, 280);
  }

  /* =========================================
     OPEN MODAL
  ========================================= */

  function openModal(card) {
    // Ignore les clics pendant qu'une autre modale est en train de s'animer
    if (isAnimating) return;

    // Si une modale est déjà ouverte, on ferme puis on ouvre la nouvelle
    // une fois l'animation terminée
    if (activeModal) {
      const nextCard = card;
      closeModal();
      setTimeout(() => openModal(nextCard), 290);
      return;
    }

    const originalModal = card.querySelector('.modal-content');
    if (!originalModal) return;

    isAnimating = true;

    // On déplace l'original (pas de clone = les event listeners sont conservés)
    sourceCard = card;
    activeModal = originalModal;
    activeModal.style.display = 'flex';
    activeModal.style.visibility = 'visible';

    // Overlay
    activeOverlay = document.createElement('div');
    activeOverlay.className = 'br-modal-overlay';
    activeOverlay.style.display = 'block';
    activeOverlay.style.visibility = 'visible';

    document.body.appendChild(activeOverlay);
    document.body.appendChild(activeModal);

    document.body.classList.add('modal-open');
    lockScroll();

    activeOverlay.addEventListener('click', closeModal);
    activeOverlay.addEventListener('touchmove', function (e) {
      e.preventDefault();
    }, { passive: false });

    const closeBtn = activeModal.querySelector('.br-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    // Listener Escape : gardé en référence pour pouvoir le retirer
    // depuis closeModal() peu importe la façon dont on ferme
    escListener = function (e) {
      if (e.key === 'Escape') closeModal();
    };
    document.addEventListener('keydown', escListener);

    requestAnimationFrame(() => {
      activeOverlay.classList.add('is-visible');
      activeModal.classList.add('is-visible');

      // Refresh des blocs internes maintenant que le modal a ses vraies dimensions
      if (typeof window.brBlocksRefreshTabs === 'function') {
        window.brBlocksRefreshTabs(activeModal);
      }
      if (typeof window.brBlocksRefreshFloorplan === 'function') {
        window.brBlocksRefreshFloorplan(activeModal);
      }

      // Animation d'ouverture terminée, on libère la garde
      setTimeout(() => { isAnimating = false; }, 280);
    });
  }

  /* =========================================
     CARD CLICK
  ========================================= */

  cards.forEach(card => {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.modal-content')) return;
      openModal(card);
    });
  });

  /* =========================================
     OPEN MODAL FROM URL HASH
  ========================================= */

  function openModalFromHash() {
    const hash = window.location.hash?.replace('#', '');
    if (!hash) return;

    const target = document.getElementById(hash);
    if (target && target.classList.contains('itu-cards-icons-item')) {
      openModal(target);
    }
  }

  openModalFromHash();

  window.addEventListener('hashchange', openModalFromHash);

});